// extracted by mini-css-extract-plugin
export default {"wrapButton":"Product_wrapButton__Feq8p"};